import {createSlice} from '@reduxjs/toolkit';

const initState = {
  token: undefined,
  drug_store: undefined,
  userinfo: undefined
};

export const authenSlice = createSlice({
  name: 'authen',
  initialState: initState,
  reducers: {
    saveAuthen: (
      state,
      action,
    ) => {
      state.token = action.payload.token;
      state.drug_store = action.payload.drug_store;
      state.userinfo = action.payload.userinfo;
    },
    clearAuthen: (state) => {
      state.token = undefined;
      state.drug_store = undefined;
      state.userinfo = undefined;
    },
  },
});

export const selectToken = (state) => state.authen.token;
export const selectUsername = (state) => state.authen.drug_store?.name;
export const selectTypeUser = (state) => state.authen.drug_store?.type;
export const selectAuthen = (state) => state.authen;

export const {saveAuthen, clearAuthen} = authenSlice.actions;

export default authenSlice.reducer;
